(function () {
  var root = document.querySelector("[data-deck-builder]");
  if (!root) return;

  var form = root.querySelector("[data-deck-form]");
  var input = root.querySelector("[data-deck-input]");
  var submit = root.querySelector("[data-deck-submit]");
  var message = root.querySelector("[data-deck-message]");
  var results = root.querySelector("[data-deck-results]");
  var summary = root.querySelector("[data-deck-summary]");
  var addButton = root.querySelector("[data-deck-add]");
  var endpoint = root.getAttribute("data-api-url");
  var state = null;

  function escapeHtml(value) {
    var node = document.createElement("div");
    node.textContent = value == null ? "" : String(value);
    return node.innerHTML;
  }

  function money(value) {
    return "¥" + Number(value || 0).toLocaleString("ja-JP");
  }

  function choiceOption(choice, selected) {
    if (!choice) return "";
    var label = choice.name + "（" + choice.set + " " + Number(choice.number) + "）";
    label += choice.inventory > 0 ? " 在庫" + choice.inventory + "枚 / " + money(choice.price) : " 売り切れ";
    return '<option value="' + escapeHtml(choice.variantId) + '" data-handle="' + escapeHtml(choice.handle)
      + '" data-price="' + choice.price + '" data-inventory="' + choice.inventory + '"'
      + (selected && selected.variantId === choice.variantId ? " selected" : "")
      + (choice.inventory <= 0 ? " disabled" : "") + ">" + escapeHtml(label) + "</option>";
  }

  function renderItem(item, index) {
    var preferred = item.preferred;
    var selected = item.selected;
    var title = preferred ? preferred.name + "（" + preferred.set + " " + Number(preferred.number) + "）" : (item.name || item.source);
    var badge = item.status === "same-effect-reprint"
      ? '<span class="deck-builder__badge">同じ効果の別収録を選択</span>'
      : item.status === "official-code"
        ? '<span class="deck-builder__badge deck-builder__badge--ok">公式デッキコードから読込</span>'
      : item.status === "preferred" ? '<span class="deck-builder__badge deck-builder__badge--ok">指定カードあり</span>'
      : item.status === "partial" ? '<span class="deck-builder__badge">一部のみ在庫あり</span>' : "";
    var alternatives = (item.alternatives || []).map(function (choice) { return choiceOption(choice, selected); }).join("");
    var control = alternatives
      ? '<select data-choice aria-label="' + escapeHtml(title) + 'の収録を選ぶ">' + alternatives + "</select>"
      : '<span class="deck-builder__unavailable">在庫のある同一効果カードが見つかりません</span>';
    var image = selected && selected.image
      ? '<img src="' + escapeHtml(selected.image) + '&width=160" alt="" loading="lazy">'
      : '<div class="deck-builder__placeholder"></div>';
    return '<article class="deck-builder__row" data-deck-row data-index="' + index + '">'
      + '<label class="deck-builder__check"><input type="checkbox" data-include ' + (selected ? "checked" : "disabled") + '><span class="visually-hidden">購入対象</span></label>'
      + '<div class="deck-builder__image">' + image + '</div>'
      + '<div class="deck-builder__details"><div class="deck-builder__title"><strong>' + item.quantity + '枚 × ' + escapeHtml(title) + '</strong>' + badge + '</div>'
      + control + '<div class="deck-builder__meta" data-row-meta></div></div></article>';
  }

  function updateSummary() {
    if (!state) return;
    var selectedCards = 0;
    var total = 0;
    results.querySelectorAll("[data-deck-row]").forEach(function (row) {
      var item = state.items[Number(row.getAttribute("data-index"))];
      var include = row.querySelector("[data-include]");
      var select = row.querySelector("[data-choice]");
      var option = select && select.options[select.selectedIndex];
      var price = option ? Number(option.getAttribute("data-price") || 0) : 0;
      var inventory = option ? Number(option.getAttribute("data-inventory") || 0) : 0;
      row.querySelector("[data-row-meta]").textContent = option
        ? money(price) + " × " + item.quantity + "枚" + (inventory < item.quantity ? "（在庫は" + inventory + "枚）" : "")
        : "";
      if (include && include.checked && option && inventory > 0) {
        var quantity = Math.min(item.quantity, inventory);
        selectedCards += quantity;
        total += price * quantity;
      }
    });
    summary.textContent = "購入可能 " + selectedCards + " / " + state.totalCards + "枚　小計 " + money(total);
    addButton.disabled = selectedCards === 0;
  }

  function render(data) {
    state = data;
    results.innerHTML = data.items.map(renderItem).join("");
    root.querySelector("[data-deck-output]").hidden = false;
    results.querySelectorAll("select,input").forEach(function (control) { control.addEventListener("change", updateSummary); });
    updateSummary();
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    submit.disabled = true;
    message.textContent = "在庫と同一効果カードを確認しています…";
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ deckText: input.value })
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) throw new Error(body.error || "在庫確認に失敗しました");
        return body;
      });
    }).then(function (data) {
      message.textContent = "";
      render(data);
    }).catch(function (error) {
      message.textContent = error.message;
    }).finally(function () {
      submit.disabled = false;
    });
  });

  addButton.addEventListener("click", function () {
    var aggregated = {};
    results.querySelectorAll("[data-deck-row]").forEach(function (row) {
      var item = state.items[Number(row.getAttribute("data-index"))];
      var include = row.querySelector("[data-include]");
      var select = row.querySelector("[data-choice]");
      var option = select && select.options[select.selectedIndex];
      if (!include || !include.checked || !option) return;
      var id = option.value;
      var inventory = Number(option.getAttribute("data-inventory") || 0);
      aggregated[id] = (aggregated[id] || 0) + Math.min(item.quantity, inventory);
    });
    var items = Object.keys(aggregated).map(function (id) { return { id: Number(id), quantity: aggregated[id] }; });
    if (!items.length) return;
    addButton.disabled = true;
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error("カートへの追加に失敗しました");
      window.location.href = window.Shopify.routes.root + "cart";
    }).catch(function (error) {
      message.textContent = error.message;
      addButton.disabled = false;
    });
  });

  var params = new URLSearchParams(window.location.search);
  var sharedDeck = params.get("deck");
  if (sharedDeck) input.value = sharedDeck;
})();
